import axios from 'axios';
import URL_CONST from '../../../config/url';
import {getHeaders} from '../../../store/dataService';
import {BinaryStrategy, BinaryStrategyTypes} from './BinaryStrategyDto';

export type AIDrivenStrategyContext = {
  projectId: string;
};

export class AIDrivenStrategy extends BinaryStrategy {
  private _projectId: string;

  static STRATEGY_NAME: BinaryStrategyTypes = 'AI-driven';

  constructor({projectId}: AIDrivenStrategyContext) {
    super(AIDrivenStrategy.STRATEGY_NAME);

    this._projectId = projectId;
  }

  async generateImages(datasetId: string, binaryId: string) {
    if (!datasetId) {
      throw new Error('Dataset ID is required');
    }

    this.isGenerating = true;

    try {
      const headers = await getHeaders({
        'Request-Timeout': 3000,
      });
      const response = await axios.post(
        URL_CONST.DATASET_KFD,
        {
          datasetId,
          projectId: this._projectId,
          videoBinaryId: binaryId,
          clientInfo: 'KFD', // Any string that will be used to determine the source of metadata
        },
        {headers}
      );
      return response.data;
    } catch (error) {
      throw error;
    } finally {
      this.isGenerating = false;
    }
  }
}
